import React from 'react';
import { CheckCircle2Icon, FileTextIcon, ShieldCheckIcon } from 'lucide-react';
import { loan, lpaAccount } from '../../data/loan';
import { DetailGroup, DetailRow, SummaryCard } from './SummaryCard';
export function FreddieSubmissionCards() {
  return <>
      <SummaryCard title="Loan Information" icon={FileTextIcon} data-id="element-93" data-mp="2gjjilummig1w">
        <div className="grid gap-6 sm:grid-cols-2 sm:gap-8" data-id="element-94" data-mp="2bjx2ndfeulpe">
          <DetailGroup label="Borrower" data-id="element-95" data-mp="396vv1bz2l7hh">
            <DetailRow label="Borrower" value={loan.borrower} data-id="element-96" data-mp="395ujl6e56iz8" />
            <DetailRow label="Coborrower" value="None" muted data-id="element-97" data-mp="34713d67h0dvd" />
            <DetailRow label="Loan Number" value={loan.loanNumber} data-id="element-98" data-mp="349nbp826qxen" />
          </DetailGroup>
          <DetailGroup label="Property" data-id="element-99" data-mp="2zehp070ylepi">
            <DetailRow label="Property Type" value={loan.propertyType} data-id="element-100" data-mp="2ui9ghch9ojrb" />
            <DetailRow label="Transaction Type" value={loan.transactionType} data-id="element-101" data-mp="3rwvglovpc4g5" />
            <DetailRow label="Property Address" value={`${loan.addressLine}, ${loan.cityStateZip}`} data-id="element-102" data-mp="3ryygr1qkjdyl" />
          </DetailGroup>
        </div>
      </SummaryCard>

      <SummaryCard title="LPA Account Information" icon={ShieldCheckIcon} data-id="element-103" data-mp="3gkinoerh7pif">
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-100 pb-3" data-id="element-104" data-mp="3kjhphqhwv65n">
          <p className="text-sm font-medium text-slate-800" data-id="element-105" data-mp="36s33daspioud">Freddie Mac Account</p>
          <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-medium text-emerald-700" data-id="element-106" data-mp="3bqefjs6h5bfr">
            <CheckCircle2Icon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-107" data-mp="2wwrpeup4hlno" />
            Authentication configured
          </span>
        </div>
        <dl className="mt-3 grid gap-2.5 sm:grid-cols-2 sm:gap-x-8" data-id="element-108" data-mp="2nuihmcl8o6dz">
          <DetailRow label="LPA ID" value={lpaAccount.lpaId} data-id="element-109" data-mp="2sstr2m7mgevo" />
          <DetailRow label="TPO Number" value={lpaAccount.tpoNumber} data-id="element-110" data-mp="2std5hsy2cl4y" />
          <DetailRow label="Branch Code" value={lpaAccount.branchCode} muted data-id="element-111" data-mp="m3f4ngnvmfq9" />
        </dl>
      </SummaryCard>
    </>;
}